import { useLayoutEffect, useState } from 'react';

// this is a custom hook that returns a boolean value indicating whether the user is on a mobile device
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useLayoutEffect(() => {
    // SSR safe: only run on client
    if (typeof window === 'undefined') return;

    const checkIsMobile = () => {
      const smScreenPx = 640;
      setIsMobile(window.innerWidth <= smScreenPx);
    };
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return isMobile;
}
